import "../../css/pageLayout.css"
import { parseJsonField } from "../../utils/parseJsonField";

function RichTextSection({ section }) {
  const settings = parseJsonField(section.settings_json);

  return (
    <section className={`rich-text-section align-${settings.alignment || "left"}`}>
      {settings.title && <h2>{settings.title}</h2>}

      {settings.body && (
        <div
          className="rich-text-body"
          dangerouslySetInnerHTML={{ __html: settings.body }}
        />
      )}
    </section>
  );
}

export default RichTextSection;